import { Link } from "@tanstack/react-router";
import { cn } from "@/lib/utils";

function Mark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 1024 1024"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-8 w-8 text-primary", className)}
    >
      <rect width="1024" height="1024" rx="200" fill="currentColor" />
      <path
        d="M458.718 792.134C426.373 775.944 404.877 767.576 378.111 741.088C359.082 722.291 343.644 694.683 338.561 684.654C326.28 660.325 318.183 613.601 321.916 588.372C325.065 566.966 345.084 525.234 352.192 525.234C354.441 525.234 371.311 532.429 389.62 541.243L422.954 557.253L413.687 569.8C401.721 585.989 398.077 614.14 405.185 635.636C412.742 658.571 441.488 688.791 473.653 707.634L500.149 723.149L519.088 712.041C582.473 674.896 609.734 625.743 590.616 583.021C575.59 549.428 567.448 545.74 470.054 528.292C403.295 516.33 353.001 482.827 331.813 436.192C317.058 403.724 318.093 347.196 334.062 312.793C386.471 200.097 549.994 176.623 636.726 269.307C662.233 296.559 664.302 316.256 643.879 336.718C623.365 357.224 607.17 353.986 576.49 323.316C555.392 302.225 527.546 293.861 488.723 296.964C439.284 300.921 406.354 328.218 401.901 368.916C400.236 383.892 402.081 391.402 410.313 403.409C426.823 427.468 440.903 435.158 481.75 442.533C579.369 460.161 596.059 465.783 628.763 492.27C651.931 510.978 673.524 553.835 677.708 589.227C686.66 665.317 633.082 744.51 540.367 792.404L500.419 813L458.718 792.134ZM477.792 658.167C456.198 634.737 451.43 620.122 459.213 601.369C470.684 573.667 505.683 566.652 526.916 587.833C541.086 601.998 544.145 621.291 535.013 639.099C529.21 650.342 503.793 678.133 499.25 678.133C497.585 678.133 487.913 669.139 477.792 658.167ZM643.114 438.531C622.51 422.701 620.666 399.002 638.66 380.968C664.032 355.605 702 370.67 702 406.062C702 435.877 665.742 455.889 643.114 438.531Z"
        className="fill-background"
      />
    </svg>
  );
}

export function Logo({
  className,
  mark = false,
  to = "/",
}: {
  className?: string;
  mark?: boolean;
  to?: string;
}) {
  if (mark) {
    return <Mark className={className} />;
  }

  const content = (
    <>
      <Mark className="h-7 w-7" />
      <span className="font-display text-lg font-bold tracking-tight text-foreground">
        Spayzo
      </span>
    </>
  );

  if (to) {
    return (
      <Link
        to={to}
        className={cn("inline-flex items-center gap-2", className)}
      >
        {content}
      </Link>
    );
  }

  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      {content}
    </span>
  );
}
